// Polyfills if needed
// require('intersection-observer');

// import external dependencies
import './util/polyfills'
import 'jquery';

// Import everything from autoload
import './autoload/_lazy-load.js'

// import local dependencies
import Router from './util/Router';
import common from './routes/common';
import Detection from './util/Detection';
import home from './routes/home';
import product from './routes/product';
import about from './routes/about';
import buy from './routes/buy';

window._detector = new Detection({
 detect: ['ie11'],
});
window._detector.init();

// /** Populate Router instance with DOM routes */
const routes = new Router({
  // All pages
  common,
  'home': home,
  'product': product,
  'about': about,
  'buy': buy,
});

// // Load Events
jQuery(document).ready(() => routes.loadEvents());
